module.exports = __webpack_public_path__ + "img/add-protocol.e22555ca.svg";